import { gql } from '@apollo/client';

export const FETCH_USAGE_REQUEST_FORM = gql`
  fragment usageRequestContractData on ContractVersion {
    contractType
    displayName
    fileUrl
    hasPersonalization
    id
    scrollRequired
    tag
    contractId
  }

  query Flex_FetchUsageRequestForm(
    $stateId: Int!
    $communitySolarProjectGroupId: Int
    $tags: [ContractTag!]
  ) {
    usageRequestForm: currentContractVersion(
      stateId: $stateId
      contractType: usage_request
      communitySolarProjectGroupId: $communitySolarProjectGroupId
      tag: $tags
    ) {
      ...usageRequestContractData
    }
  }
`;
